export type SearchSize = 'S' | 'M' | 'L';
export type SearchVariant = 'basic' | 'global';
export type SearchState = 'enabled' | 'hover' | 'focused' | 'autosuggestion' | 'filled' | 'filled-hover' | 'disabled';

export const SEARCH_SIZE: Readonly<Record<'S' | 'M' | 'L', SearchSize>> = {
  S: 'S',
  M: 'M',
  L: 'L',
};

export const SEARCH_VARIANT: Readonly<Record<'BASIC' | 'GLOBAL', SearchVariant>> = {
  BASIC: 'basic',
  GLOBAL: 'global',
};

export const SEARCH_STATE: Readonly<
  Record<'ENABLED' | 'HOVER' | 'FOCUSED' | 'AUTOSUGGESTION' | 'FILLED' | 'FILLED_HOVER' | 'DISABLED', SearchState>
> = {
  ENABLED: 'enabled',
  HOVER: 'hover',
  FOCUSED: 'focused',
  AUTOSUGGESTION: 'autosuggestion',
  FILLED: 'filled',
  FILLED_HOVER: 'filled-hover',
  DISABLED: 'disabled',
};
